<template>
<usertables
  v-bind:title="'Personality'"
  v-bind:section="'personality'"
  ></usertables>
</template>

<script>
  import Usertables from './userTables'
  export default {
    name: 'Personality',
    components: {Usertables}
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/user-class/personality.vue